import moment from "moment"

export const dateTimeToView = (date?: any, isFullYear = true, locales = 'th') => {
  let today: any = Date.now()
  if (date) today = new Date(date)
  if (date === '-') {
    return '-'
  }
  if (locales === 'th') {
    const month = moment(date).format('MM')
    const year = Number(moment(date).format('YYYY')) + 543
    const dateOfData = moment(date).format('DD')
    const timeOfData = moment(date).format('HH:mm')
    const newDate = `${dateOfData}/${month}/${isFullYear ? year : year.toString().substring(2, 4)} ${timeOfData}  น.`
    return newDate
  }
  return (
    new Intl.DateTimeFormat(locales, {
      year: isFullYear ? 'numeric' : '2-digit',
      month: '2-digit',
      day: '2-digit',
      hour: 'numeric',
      minute: 'numeric',
      hour12: false
    }).format(today) + ' น.'
  )
}
export const dateToView = (date?: any, isFullYear = true, locales = 'th') => {
  let today: any = Date.now()
  if (date) today = new Date(date)

  if (locales === 'th') {
    const month = moment(date).format('MM')
    const year = Number(moment(date).format('YYYY')) + 543
    const dateOfData = moment(date).format('DD')
    const newDate = `${dateOfData}/${month}/${isFullYear ? year : year.toString().substring(2, 4)}`
    return newDate
  }
  return new Intl.DateTimeFormat(locales, {
    year: isFullYear ? 'numeric' : '2-digit',
    month: '2-digit',
    day: '2-digit'
  }).format(today)
}

export const dateMonthToView = (date?: any, isFullYear = true, locales = 'th') => {
  let today: any = Date.now()
  const monthTh = [
    "มกราคม",   // January
    "กุมภาพันธ์", // February
    "มีนาคม",    // March
    "เมษายน",   // April
    "พฤษภาคม",  // May
    "มิถุนายน",  // June
    "กรกฎาคม",  // July
    "สิงหาคม",   // August
    "กันยายน",   // September
    "ตุลาคม",   // October
    "พฤศจิกายน", // November
    "ธันวาคม"   // December
  ];
  if (date) today = new Date(date)

  if (locales === 'th') {
    const month = moment(date).format('MM')
    const year = Number(moment(date).format('YYYY')) + 543
    const dateOfData = moment(date).format('DD')
    const newDate = `${dateOfData} ${monthTh[Number(month) - 1]} พ.ศ. ${isFullYear ? year : year.toString().substring(2, 4)}`
    return newDate
  }
  if (locales === 'en') {
    const date = moment(today)
    const day = date.format('D')
    const monthEng = date.locale('en').format('MMMM')
    const year = date.format('YYYY')
    return `${day} ${monthEng} ${year}`
  }
  return new Intl.DateTimeFormat(locales, {
    year: isFullYear ? 'numeric' : '2-digit',
    month: '2-digit',
    day: '2-digit'
  }).format(today)
}

export const timeToView = (date?: any, isFullYear = true, locales = 'th') => {
  let today: any = Date.now()
  if (date) today = new Date(date)

  return new Intl.DateTimeFormat(locales, {
    hour: 'numeric',
    minute: 'numeric',
    hour12: false
  }).format(today)
}

/**
 * วัดความสูงของ element แล้วแปลงเป็น mm
 * @param el โหนด DOM ที่เราจะแปลงความสูง
 * @returns ความสูงเป็น mm (จำนวนจริง)
 */
export const getElementHeightMm = (el: HTMLElement): number => {
  const rect = el.getBoundingClientRect();
  const heightPxRaw = rect.height;
  const style = window.getComputedStyle(el);
  let scaleY = 1;
  const transform = style.transform;
  if (transform && transform !== 'none') {
    const m = transform.match(/matrix\(([^)]+)\)/);
    if (m) {
      const vals = m[1].split(',').map(v => parseFloat(v));
      if (vals.length === 6) {
        scaleY = vals[3];
      }
    }
  }

  const heightPx = heightPxRaw / scaleY;
  const DPI = 96;
  const MM_PER_INCH = 25.4;
  const heightMm = (heightPx / DPI) * MM_PER_INCH;
  return heightMm;
}


export const convertDurationToMinuteOrText = (duration: any, type = '') => {
  /** CONVERT TO MINUTES */
  if (type === 'MINUTES') return Number(duration)
  else if (type === 'HOURS') {
    duration = duration.split('.')
    if (duration.length > 1) return Number(duration[0]) * 60 + Number(duration[1])
    else return Number(duration[0]) * 60
  } else if (type === 'DAY') return Number(duration) * 24 * 60

  /** CONVERT TO TEXT */
  duration = Number(duration)
  const min = Number(duration % 60)
  if (duration < 60) return duration + ' นาที'
  else if (duration >= 60 && duration < duration * 24 * 60) return Number((duration - min) / 60) + (min > 0 ? '.' + min : '') + ' ชั่วโมง'
  else return duration / 24 / 60 + ' วัน'
}

enum SHORT_DAY_OF_WEEK {
  Sun = `Sun`,
  Mon = `Mon`,
  Tue = `Tue`,
  Wed = `Wed`,
  Thu = `Thu`,
  Fri = `Fri`,
  Sat = `Sat`
}

export const dateOfWeek = (type: any = 'SHORT') => {
  return type === 'SHORT' ? SHORT_DAY_OF_WEEK : []
}

export const fullDateToView = (date?: any, isFullYear = true, locales = 'th') => {
  let today: any = Date.now()
  if (date) today = new Date(date)
  return new Intl.DateTimeFormat(locales, {
    year: 'numeric',
    month: 'long'
  }).format(today)
}


export const fullDateAndTimeToView = (date?: any, locales = 'th') => {
  const originalDate = moment(date);
  originalDate.locale(locales);
  const buddhistYear = originalDate.year() + 543;
  const formatted = `วัน${originalDate.format('dddd')}ที่ ${originalDate.format('D MMMM')} ${buddhistYear} เวลา ${originalDate.format('HH:mm')} น.`;
  return formatted
}
